import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// material ui
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';

export default class DeviceNotifications extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  render() {
    var approaching = this.props.limit && this.props.total / this.props.limit > 0.8;
    var warning = this.props.limit && this.props.limit <= this.props.total;
    return (
      <div>
        <div id="limit" data-tip data-for="limit-tip" data-offset="{'bottom': 0, 'right': 0}" data-tip-disable={!this.props.limit}>
          <div className="header-section">
            <Link to="/devices" className={warning ? 'warning inline' : approaching ? 'approaching inline' : 'inline'}>
              <span>{this.props.total}</span>
              <DeveloperBoardIcon style={{ margin: '0 7px 0 10px', fontSize: '20px' }} />
            </Link>

            {this.props.pending ? (
              <Link
                to="/devices/pending"
                style={{ marginLeft: '7px' }}
                className={this.props.limit && this.props.limit < this.props.pending + this.props.total ? 'warning' : null}
              >
                {this.props.pending} unauthorized
              </Link>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
